module.exports = __webpack_public_path__ + "static/media/JiaoYu5.d680e5b1.png";